import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Button, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { styled as materialStyled } from '@mui/system';
import { CommonButtonV1 } from 'gemlux-common-components';
import WriteNewChatIcon from '../../../assets/img/V1/new-chat-icon.svg';
import { theme } from '../../../theme/theme';
import DeleteIcon from '../../../assets/img/V1/delete-icon.svg';
import { filterScrollbarStyles } from '../../../utils/styles';
import { IChatHistoryData } from '../../../redux/gemGPT/gemGPTslice';

export const CustomButton = materialStyled(Button)(({ selected }: { selected: boolean }) => ({
  color: selected ? theme.palette.shades.primaryBrightDark : theme.palette.black.main,
  padding: '0px',
  '&:hover': {
    backgroundColor: theme.palette.secondary.light,
  },
}));

const CustomGridContainer = materialStyled(Grid)({
  marginTop: '16px',
  rowGap: '16px',
  width: '100%',
  maxHeight: '70vh',
  overflowY: 'auto',
  ...filterScrollbarStyles,
});

interface GemGPTChatHistoryProps {
  selectedChatId: string;
  chatHistoryList: IChatHistoryData[];
  handleSelectOption: (_chatId: string) => void;
  handleDeleteChat: (_chatId: string) => void;
  handleCreateNewChat: () => void;
}

const GemGPTChatHistory = ({
  selectedChatId,
  chatHistoryList,
  handleSelectOption,
  handleDeleteChat,
  handleCreateNewChat,
}: GemGPTChatHistoryProps) => (
  <Grid container>
    <Grid item xs={12} sm={12} pr={4}>
      <CommonButtonV1
        radius="12px"
        fullWidth
        startIcon={<Grid component="img" src={WriteNewChatIcon} alt="Write New Chat" />}
        onClick={handleCreateNewChat}
      >
        <Typography variant="textBase" color="HighlightText">
          New Chat Topic
        </Typography>
      </CommonButtonV1>
    </Grid>
    <CustomGridContainer container>
      {chatHistoryList.map((chat) => (
        <Grid
          key={uuidv4()}
          item
          xs={12}
          sm={12}
          sx={{
            padding: '5px',
          }}
        >
          <Grid item mb={1}>
            <Typography variant="textSM" color="#6F7C8E">
              {chat.chatDateRange}
            </Typography>
          </Grid>

          {chat.chatHistory.map((chatHistory) => (
            <Grid
              item
              xs={10}
              sm={10}
              key={uuidv4()}
              sx={{
                padding: '10px',
                backgroundColor: selectedChatId === chatHistory.chatId ? '#E0EDFF' : 'transparent',
                borderRadius: '8px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                mb: 1,
              }}
            >
              <CustomButton
                variant="text"
                selected={selectedChatId === chatHistory.chatId}
                onClick={() => handleSelectOption(chatHistory.chatId)}
              >
                <Tooltip
                  title={chatHistory.chatTitle}
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        bgcolor: '#000',
                        '& .MuiTooltip-arrow': {
                          color: '#000',
                        },
                        color: '#fff',
                      },
                    },
                  }}
                >
                  <Typography
                    variant="textBase500"
                    sx={{
                      display: 'block',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      maxWidth: 'auto',
                      textOverflow: 'ellipsis',
                      wordBreak: 'break-word',
                    }}
                  >
                    {chatHistory.chatTitle}
                  </Typography>
                </Tooltip>
              </CustomButton>

              {selectedChatId === chatHistory.chatId && (
                <IconButton onClick={() => handleDeleteChat(chatHistory.chatId)}>
                  <Grid component="img" src={DeleteIcon} alt="Delete Chat" height="20px" />
                </IconButton>
              )}
            </Grid>
          ))}
        </Grid>
      ))}
    </CustomGridContainer>
  </Grid>
);

export default GemGPTChatHistory;
